// Chamadas do checkout transparente de assinatura (rotas em
// backend/src/routes/subscriptionsRoutes.ts). O cartão nunca passa por aqui:
// só o token gerado pelo Brick do Mercado Pago.
import api from "../../services/api";

const getCheckout = async () => {
  const { data } = await api.get("/subscriptions/checkout");
  return data;
};

const create = async (body) => {
  const { data } = await api.post("/subscriptions", body);
  return data;
};

const payInvoice = async (invoiceId, body) => {
  const { data } = await api.post(`/subscriptions/invoices/${invoiceId}/pay`, body);
  return data;
};

const me = async () => {
  const { data } = await api.get("/subscriptions/me");
  return data;
};

// "Já paguei": o backend consulta o Mercado Pago e aplica o que o webhook
// ainda não entregou; devolve o mesmo resumo de `me` + `reconciled`.
const reconcile = async () => {
  const { data } = await api.post("/subscriptions/me/reconcile");
  return data;
};

const patchMe = async (body) => {
  const { data } = await api.patch("/subscriptions/me", body);
  return data;
};

// Super admin (isSuper no backend): assinatura de uma empresa e cancelamento.
const byCompany = async (companyId) => {
  const { data } = await api.get(`/subscriptions/company/${companyId}`);
  return data;
};

const cancelByCompany = async (companyId) => {
  const { data } = await api.patch(`/subscriptions/company/${companyId}`, {
    action: "cancel",
  });
  return data;
};

// Funções sem estado: o mesmo objeto sempre, seguro em deps de useEffect.
const API = Object.freeze({ getCheckout, create, payInvoice, me, reconcile, patchMe, byCompany, cancelByCompany });

const useSubscription = () => API;

export default useSubscription;
